
import Popover from './controllable-popover.vue';
import FrameSequence from '@/components/FrameSequence/index.vue';

export default {
  name: 'ImagePreviewPopover',
  components: { Popover: Popover, FrameSequence: FrameSequence },
  provide: function provide() {
    var _this = this;

    return {
      show: function show(src, type) {
        _this.showSource(src, type, function () {
          _this.$refs.popover && _this.$refs.popover.show && _this.$refs.popover.show();
        });
      },
      hide: function hide() {
        _this.hideSource();
      }
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // 预览位置是否自适应布局
    autoLayout: {
      type: Boolean,
      default: false
    },
    popoverProps: {
      type: Object,
      // see: https://popper.js.org/documentation.html
      default: function _default() {
        return {};
      }
    },
    /**
     * 预览图片的Props
     */
    previewProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      src: '',
      type: 'image' // image effect
    };
  },

  watch: {
    disabled: function disabled(bool) {
      if (bool) {
        this.hideSource();
      }
    }
  },
  computed: {
    isImage: function isImage() {
      return typeof this.src === 'string';
    },
    isXlz: function isXlz() {
      return Array.isArray(this.src);
    }
  },
  methods: {
    showSource: function showSource(src, type, showHandler) {
      if (!this.disabled) {
        this.src = src;
        this.type = type || 'image';
        showHandler();
      } else {
        this.hideSource();
      }
    },
    hideSource: function hideSource() {
      this.$refs.popover && this.$refs.popover.hide && this.$refs.popover.hide();
    }
  }
};